<template>
  <el-dialog :title='title' :visible.sync="dialogVisible" :close-on-click-modal="false" width="80rem">
    <div class="cover-box" v-if="form.type != '图片'">
      <div>资源封面</div>
      <el-upload style="width: 50px !important; height: 50px !important" action="#" accept=".jpg,.jpeg,.png"
        list-type="picture-card" :auto-upload="false" :show-file-list="false" class="upload-box-img"
        :on-change="handleFm">
        <img v-if="form.coverPath" :src="$severUrl(form.coverPath)" style="width: 48px; height: 48px" />
        <i v-else class="el-icon-plus"></i>
      </el-upload>
    </div>
    <div class="resource-name">
      <div>资源名称</div>
      <el-input style="width: 20rem;" v-model="form.resourceName" placeholder="请输入资源名称"></el-input>
    </div>
    <div class="resource-name">
      <div>资源编码</div>
      <el-input style="width: 20rem;" v-model="form.softwareCode" placeholder="请输入资源编码"></el-input>
    </div>
    <div class="resource-name" style="border-bottom: 1px solid #EAEBF0;">
      <div>资源介绍</div>
      <el-input style="width: 100%;" type="textarea" v-model="form.info" placeholder="请输入资源介绍"></el-input>
    </div>
    <div class="upload-box-content">
      <div class="item-bottom">
        <div class="title-text">所属分类</div>
        <el-radio-group v-model="form.resourceCategory">
          <el-radio :label="item.value" v-for="(item, index) in Category" :key="index">{{ item.label }}</el-radio>
        </el-radio-group>
      </div>
      <div class="item-bottom">
        <div class="title-text">资源类型</div>
        <el-radio-group v-model="form.resType" @input="changeType">
          <el-radio label="单机">单机</el-radio>
          <el-radio label="网页">网页</el-radio>
        </el-radio-group>
      </div>
      <div class="item-bottom" v-if="form.resType=='网页'">
        <div class="title-text">资源链接</div>
        <el-input style="width: 20rem;" v-model="form.url" placeholder="请输入资源链接"></el-input>
      </div>
      <div class="item" v-show="form.resType=='单机'">
        <upload-chunk style="width: 100%;" :multiple="false" ref="chunk" accept=".exe,.zip" @upload="upload"
          @del_file="upload"></upload-chunk>
      </div>
      <div class="item-bottom" v-if="form.resType=='单机'">
        <div class="title-text">启动文件</div>
        <el-input style="width: 20rem;" v-model="form.regedit" maxlength="500" placeholder="例如：idea64.exe 或 bin\launcher.exe"></el-input>
        <span class="entry-exe-tip">可不填，安装时由用户选择</span>
      </div>
      <div class="item-bottom">
        <div class="title-text">实训目标</div>
        <el-input style="width: calc(100% - 15rem)" type="textarea" v-model="form.drillTarget" placeholder="请输入实训目标"></el-input>
      </div>
      <div class="item-bottom">
        <div class="title-text">实训原理</div>
        <el-input style="width: calc(100% - 15rem);" type="textarea" v-model="form.drillTheory" placeholder="请输入实训原理"></el-input>
      </div>
      <div class="item-bottom">
        <div class="title-text">实训步骤</div>
        <el-input style="width: calc(100% - 15rem);" type="textarea" v-model="form.drillStep" placeholder="请输入实训步骤"></el-input>
      </div>
      <div class="item-bottom">
        <div class="title-text">实训方法与过程</div>
        <el-input style="width: calc(100% - 15rem);" type="textarea" v-model="form.drillMethodCourse"
          placeholder="请输入实训方法与过程"></el-input>
      </div>
      <div class="item-bottom">
        <div class="title-text">实训结论</div>
        <el-input style="width: calc(100% - 15rem);" type="textarea" v-model="form.drillConclusion" placeholder="请输入实训结论"></el-input>
      </div>
      <div class="item-bottom">
        <div class="title-text">硬件要求</div>
        <el-input style="width: calc(100% - 15rem);" type="textarea" v-model="form.hardwareAsk" placeholder="请输入硬件要求"></el-input>
      </div>
      <div class="item-bottom">
        <div class="title-text">操作系统</div>
        <el-input style="width: calc(100% - 15rem);" type="textarea" v-model="form.os" placeholder="请输入操作系统"></el-input>
      </div>
      <div class="item-bottom">
        <div class="title-text">网络要求</div>
        <el-input style="width: calc(100% - 15rem);" type="textarea" v-model="form.networkAsk" placeholder="请输入网络要求"></el-input>
      </div>
    </div>
    <div class="btn-box">
      <el-button size="large" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" v-debounce="save" size="large" style="margin-left: 3.5rem;">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { uploadFile } from '@/assets/js/oss';
import { AddSoftware, UpdateSoftware } from '@/api/software';
import UploadChunk from './UploadChunk.vue';
import { Category } from '@/utils/utils';
export default {
  props: ['resourceType'],
  components: { UploadChunk },
  data() {
    return {
      Category,
      title: '上传资源',
      operation: '',
      resourceId: '',
      dialogVisible: false,
      form: {
        resourceCategory: 'CIS',
        softwareCode:'',
        info: '',
        resourceName: '',
        coverPath: '',
        coverFileId: '',
        fileId:'',
        fileName:'',
        url: '',
        regedit: '',
        resType:'单机',
        drillTarget: '',
        drillTheory: '',
        drillStep: '',
        drillMethodCourse: '',
        drillConclusion: '',
        hardwareAsk: '',
        os: '',
        networkAsk: ''
      },
    }
  },
  methods: {
    /**清空表单 */
    clearFrom() {
      var dialog=this.$refs.chunk;
      dialog&&(dialog.fileArr=[]);
      this.resourceId='';
      this.form = {
        resourceCategory: 'CIS',
        softwareCode: '',
        info: '',
        resourceName: '',
        coverPath: '',
        coverFileId: '',
        url: '',
        regedit: '',
        fileName:'',
        fileId:'',
        resType:'单机',
        drillTarget: '',
        drillTheory: '',
        drillStep: '',
        drillMethodCourse: '',
        drillConclusion: '',
        hardwareAsk: '',
        os: '',
        networkAsk: ''
      }
    },
    setChunkDefault(){
      if(!this.form.fileId)return;
            var dialog=this.$refs.chunk;
            let data={
              fileName:this.form.fileName,
              id:this.form.fileId,
              status:'success'
            }
            if(dialog){
              dialog.fileArr=[data];
            }
          },
    /**上传封面 */
    handleFm(e) {
      uploadFile(e.raw).then(res => {
        this.form.coverPath = res.fileUrl;
        this.form.coverFileId = res.id;
      })
    },
    /**切换软件类型 */
    changeType(){
      this.$nextTick(()=>{
        if(this.form.resType=='单机'){
          this.setChunkDefault();
        }
      })
    },
    removeFile() {
      this.form.fileList = null;
    },
    upload(e) {
      if(e.length>0){
        this.form.fileId=e[0].id;
        this.form.fileName=e[0].fileName;
      }else{
        this.form.fileId='';
        this.form.fileName='';
      }
    },
    /**校验 */
    verification() {
      var obj = {
        resourceName: '资源名称不能为空',
        resourceCategory: '所属分类不能为空',
        // url: '资源链接不能为空',
      }
      for (let key in obj) {
        if (!this.form[key]) {
          this.$msg({
            showClose: true,
            message: obj[key],
            type: "warning",
          });
          return false;
        }
      }
      return true;
    },
    save() {
      if (!this.verification()) return;
      var params = {
        "classify": this.form.resourceCategory,
        "explainInfo": this.form.info,
        "orderIndex": '',
        "softwareCode": this.form.softwareCode,
        "softwareCover": this.form.coverPath,
        "softwareName": this.form.resourceName,
        "drillConclusion":this.form.drillConclusion,
        "drillMethodCourse":this.form.drillMethodCourse,
        "drillStep":this.form.drillStep,
        "drillTheory":this.form.drillTheory,
        "drillTarget":this.form.drillTarget,
        "hardwareAsk":this.form.hardwareAsk,
        "networkAsk":this.form.networkAsk,
        "os":this.form.os,
        "resType":this.form.resType,
      }
      if(this.form.resType=='单机'){
        params.fileId=this.form.fileId;
        params.url=this.form.fileName;
        params.regedit=this.form.regedit;
      }else{
        params.url=this.form.url;
      }
      if (this.operation == 'edit') {
        params.id = this.resourceId;
        UpdateSoftware(params).then(res => {
          if (res.code == 200) {
            this.$msg({
              showClose: true,
              message: "修改资源成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit('create_resource');
            return;
          }
        })
      }
      else {
        AddSoftware(params).then(res => {
          if (res.code == 200) {
            this.$msg({
              showClose: true,
              message: "创建资源成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit('create_resource', {
              resourceName: res.data.resourceName,
              resourceId: res.data.resourceId,
              classifyCode: this.form.resourceCategory
            });
          }
        })
      }
    }
  },
}
</script>

<style lang="less" scoped>
.cover-box {
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  color: #8590B3;

  &> :nth-child(1) {
    margin-right: 1rem;
  }
}
.title-text{
  width: 12rem;
}
.upload-box-content{
  height: 30rem;
  overflow: auto;
  padding-bottom: 1rem;
}
.upload-box-img {
  /deep/.el-upload {
    width: 5rem;
    height: 5rem;
    position: relative;
  }

  /deep/.el-icon-plus {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

/deep/.el-dialog__title {
  color: #334681;
  font-weight: 700;
  font-size: 16px;
}

/deep/.el-dialog {
  border-radius: 16px;
}

.resource-name {
  display: flex;
  padding-bottom: 2.8rem;

  &> :nth-child(1) {
    margin-right: 1rem;
    color: #8590B3;
    font-size: 14px;
  }
}

.item {
  display: flex;
  align-items: center;
  margin-top: 3rem;

  &> :nth-child(1) {
    color: #334681;
    font-size: 14px;
    margin-right: 1rem;
  }
}
.item-bottom {
  display: flex;
  align-items: center;
  margin-top: 3rem;

  &> :nth-child(1) {
    color: #334681;
    font-size: 14px;
  }
}
.upload-box {
  margin-top: 3rem;
}

.tip {
  color: #8590B3;
  font-size: 14px;
  margin-top: 0.5rem;
}

.entry-exe-tip {
  margin-left: 1rem;
  color: #8590B3;
  font-size: 13px;
}

.btn-box {
  margin: 3.5rem 0;
  text-align: center;
}

/deep/.el-upload--picture-card {
  border: 1px solid #e8ecef;
  background: #ffffff;
}

.el-icon-plus {
  font-size: 1rem;
}

/deep/.el-dialog__header {
  background-image: url('../../assets/image/magSys/top.png');
  border-top-right-radius: 16px;
}

/deep/.el-input__inner {
  padding-left: 1.5rem !important;
}
</style>
